import React from "react";
import { Table } from "src/modules/Submissions/Table";
import Submission from "src/types/Submission";
import { formatDate } from "src/utils/format";

const COLUMNS = [
  {
    Header: "Submission Period Name",
    name: "SubmissionPeriod",
    key: "submissionPeriod",
    accessor: (s: Submission) => s.submissionPeriod?.name,
  },
  {
    Header: "Due Date",
    name: "DueDate",
    key: "submissionPeriod.dueDate",
    accessor: (s: Submission) => formatDate(s.submissionPeriod?.dueDate),
  },
  {
    Header: "Submitted Date",
    name: "Submitted Date",
    key: "submittedOn",
    sortable: true,
    accessor: (s: Submission) => formatDate(s.submittedOn),
  },
  {
    Header: "Submitted By",
    name: "Submitted By",
    key: "submittedByName",
    sortable: true,
    accessor: ({ submittedByName }: Submission) => (
      <div>{submittedByName ?? ""}</div>
    ),
  },
  {
    Header: "Total Lines",
    name: "Total Lines",
    accessor: "totalServiceLinesSubmitted",
    key: "totalServiceLinesSubmitted",
    sortable: true,
  },
  {
    Header: "Percent Known",
    name: "Percent Known",
    accessor: (submission: Submission) =>
      submission ? <>{submission.percentKnown}% Known</> : <></>,
    key: "percentKnown",
    sortable: true,
  },
  {
    Header: "Lead",
    name: "Lead",
    accessor: "totalServiceLinesLead",
    key: "totalServiceLinesLead",
    sortable: true,
  },
  {
    Header: "GRR",
    name: "GRR",
    accessor: "totalServiceLinesGalvanized",
    key: "totalServiceLinesGalvanized",
    sortable: true,
  },
  {
    Header: "Unknown",
    name: "Unknown",
    accessor: "totalServiceLinesUnknown",
    key: "totalServiceLinesUnknown",
    sortable: true,
  },
  {
    Header: "Non-lead",
    name: "Non-lead",
    accessor: "totalServiceLinesNonLead",
    key: "totalServiceLinesNonLead",
    sortable: true,
  },
];

interface Props {
  systemId: string;
  isOnUtilityDetailsPage?: boolean;
}

export const InventorySubmissionTable: React.FC<Props> = ({
  systemId,
  isOnUtilityDetailsPage,
}) => {
  return (
    <Table
      columns={COLUMNS}
      isOnUtilityDetailsPage={isOnUtilityDetailsPage}
      systemId={systemId}
    />
  );
};
